import moment from 'moment';
import { icons } from '~/assets';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Input from '~/components/input';
import Tabs from '~/components/tab/index';
import useApi, { ApiMethod } from '~/hooks/useApi';
import { useModal } from '~/hooks/useModal';
import { ReprocessamentoFaturaDados } from '~/models/reprocessamento-fatura';
import Endpoints from '~/services/endpoints';
import Constants from '~/utils/constants';
import { useInvoiceReprocess } from '../context';
import { Header } from './header';
import TransactionTable from './transactionTable';

export const ConfirmSolicitationDialogContent = ({
  data,
}: {
  data: ReprocessamentoFaturaDados;
}) => {
  const {
    setTicketNumber,
    clearData,
    clientData,
    ticketNumber,
    selectedItems,
    changeDate,
    newDate,
    invoiceData,
  } = useInvoiceReprocess();
  const PostNewSolicitation = useApi({
    url: Endpoints.reprocess.postNewSolicitation,
    method: ApiMethod.POST,
    fetchOnMount: false,
  });
  const { closeModal, openModal } = useModal();

  const onSubmitNewSolicitation = async () => {
    const user = JSON.parse(localStorage.getItem(Constants.USER));
    const isOnlyChangingDate =
      Object.entries(selectedItems).every((s) => s[1].length === 0) &&
      changeDate;
    const body = {
      cpf: clientData.cpf,
      // caso esteja apenas mudando a data de vencimento, vai enviar para o back o idFatura da ultima fatura (mais atual)
      faturas: isOnlyChangingDate
        ? [{ idFatura: invoiceData.at(-1).idFatura, lancamentosRemover: [] }]
        : Object.entries(selectedItems)
            .filter((l) => l[1]?.length > 0)
            .map(([key, value]) => {
              return {
                idFatura: key,

                lancamentosRemover: value.map((s) => s.idTransacao),
              };
            }),
      idOperador: user?.id,
      nomeOperador: user?.nomeTitular,
      numeroProtocoloInterno: ticketNumber,
    };
    if (changeDate) {
      Object.assign(body, {
        dataNovoVencimento: moment(newDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      });
    }
    const response = await PostNewSolicitation.callApi(body);
    if (response.success) {
      openModal({
        message: 'Já disponível para um aprovador',
        title: 'Solicitação registrada!',
        icon: icons.checkGreen,
        widthInPercent: 30,
        positiveAction: () => {
          clearData();
          closeModal();
        },
      });
    } else {
      openModal({
        icon: icons.exclamation,
        message: response?.mensagem || 'Erro',
        title: 'Houve um erro',
      });
    }
  };
  if (!data) return null;
  return (
    <div style={{ maxHeight: '70vh' }}>
      <Tabs initialTab={0}>
        {invoiceData?.map((f) => {
          return (
            <Tabs.Tab
              label={`Fatura ${moment(f.dataVencimento, 'YYYY-MM-DD').format(
                'DD/MM/YYYY',
              )}`}
              disabled={false}
            >
              <ContainerFlex
                flex={1}
                style={{
                  minHeight: '400px',
                  maxHeight: '50vh',
                  overflowY: 'auto',
                }}
              >
                <Header label="Transações para remover" />

                <TransactionTable resumedView data={f} />
              </ContainerFlex>
            </Tabs.Tab>
          );
        })}
      </Tabs>
      <ContainerFlex padding={16}>
        <Input
          label="Informe o número do chamado"
          value={ticketNumber}
          onChange={(e) => setTicketNumber(e.target.value)}
          placeholder="#1234"
          maxLength={14}
        />
      </ContainerFlex>
      <ContainerFlex row end gap="8" marginTop={16}>
        <Button outlined onClick={() => closeModal()}>
          Voltar
        </Button>
        <Button
          loading={PostNewSolicitation.loading}
          disabled={PostNewSolicitation.loading || !ticketNumber}
          onClick={onSubmitNewSolicitation}
        >
          Solicitar reprocessamento
        </Button>
      </ContainerFlex>
    </div>
  );
};
